import {cryptoPacket} from './cryptoPacket';
import axios,{AxiosRequestConfig} from "axios";
import {KeyResponse10,reConnectParamerter,keyUpdateParamerter} from "./keyEx";
import {encode as base64Encode,decode as base64Decode} from "base64-arraybuffer";
import {getCyptoParamerter} from "./index";

export interface ConectParms{
    "saver":{
        "host":string,
        "keyExchangePoint":string,
        "clientAuthPoint":string,
        "ottEndPoint":string,
        "cert":JsonWebKey,
        "cryptoParamerter":string,
    },
    "client":{
        "clientId":string,
        "clientSecret":string,
    },
    "headerPrefix":string,
}
export interface ApiResponseData{
    statusCode:number, //HTTP status
    debug:any,
    data:unknown,//API 応答ペイロード
    file?:{
        fileName:string,
        fileBuffer:BufferSource,
    }
}
export interface RequestPram{
    "method":"GET"|"POST"|"PUT"|"DELETE",
    "path":string,
    "params"?:{[key:string]:any},
    "body"?:any
}

const contentDispositionFilenameReg = new RegExp(`filename=[\\"\\'](.+)[\\"\\']`);

export class CSession{
    private crypto:cryptoPacket;
    private conectParms:ConectParms;
    private myKey?:JsonWebKey;
    private sessionId?:string;
    private keyId?:string;
    private reConectData:reConnectParamerter|null;
    private seqNo:number;
    private headerPrefix:string;
    private connectionProccess:boolean;
    
    constructor(parms:ConectParms){
        const cryptoPram = getCyptoParamerter(parms.saver.cryptoParamerter);
        if(!cryptoPram){
            throw new Error(`CSession Crypto paramertername is not supported.\r\n Pramerter name:${parms.saver.cryptoParamerter}`);
        }
        this.crypto = new cryptoPacket(cryptoPram);
        this.conectParms = parms;
        this.reConectData = null;
        this.seqNo = 0;
        this.headerPrefix = parms.headerPrefix;
        this.connectionProccess = false;
    }
    private connectionWait(){
        return new Promise((resole,reject)=>{
            setImmediate(()=>{
                return resole(this.connectionProccess);
            });
        });
    }
    public async conect(option?:{reConnect?:reConnectParamerter,keyUpdate?:keyUpdateParamerter}){
        if(this.connectionProccess){
            while (await this.connectionWait());
            return this.sessionId?true:false;
        }
        this.connectionProccess = true;
        this.myKey = await this.crypto.generateKeyPair();
        if(!this.myKey){
            return false;
        }
        //鍵交換
        const requestBody = (()=>{
            if(option?.reConnect){
                return{
                    "version":"1.0",
                    "payload":{
                        "algrithm":this.conectParms.saver.cryptoParamerter,
                        "publickey":this.myKey,
                        "recon":option.reConnect,
                    }
                }
            }else if(option?.keyUpdate){
                return{
                    "version":"1.0",
                    "payload":{
                        "algrithm":this.conectParms.saver.cryptoParamerter,
                        "publickey":this.myKey,
                        "keyUpdate":option.keyUpdate,
                    }
                }
            }else{
                return{
                    "version":"1.0",
                    "payload":{
                        "algrithm":this.conectParms.saver.cryptoParamerter,
                        "publickey":this.myKey,
                    }
                }
            }
        })();
        const keyexResponse = await axios({
            "method":"POST",
            "url":this.conectParms.saver.host + this.conectParms.saver.keyExchangePoint,
            "data":requestBody,
        }).then(_=>_).catch(err=>{
            return null;
        });
        if(!keyexResponse){
            this.connectionProccess = false;
            return false;
        }
        if(keyexResponse && keyexResponse.status === 200){
            //サーバー検証
            if(!responseVersionCheck.v_1_0(keyexResponse.data)){
                console.error("非対応のバージョン情報が返されました");
                this.connectionProccess = false;
                return false;
            }
            const serverKey = keyexResponse.data.payload.key.publicKey;
            const sessionId = keyexResponse.data.payload.sessionID;
            if(!serverKey || !sessionId){
                this.connectionProccess = false;
                return false;
            }
            await this.crypto.importKey(serverKey);
            const sign = await this.crypto.decrypt(new Uint8Array(base64Decode(keyexResponse.data.payload.sign)));
            if(sign){
                const _singTgt = new TextEncoder().encode(`${sessionId},${keyexResponse.data.payload.key.keyId},${serverKey.x},${serverKey.y}`);
                if(!await  this.crypto.verifySign(this.conectParms.saver.cert,_singTgt,new Uint8Array(sign))){
                    //署名検証失敗
                    console.error("署名検証に失敗しました");
                    this.connectionProccess = false;
                    return false;
                }else{
                    this.keyId = keyexResponse.data.payload.key.keyId;
                    this.sessionId = sessionId;
                    this.seqNo = 1;
                }
            }else{
                console.error("鍵交換が不正です");
                delete this.sessionId;
                this.connectionProccess = false;
                return false;
            }
        }else{
            delete this.sessionId;
            this.connectionProccess = false;
            return false;
        }
        //クライアント認証
        const clientAuthResponse = await this.request({
            "method":"POST",
            "path":this.conectParms.saver.clientAuthPoint,
            "body":{
                "clientId":this.conectParms.client.clientId,
                "sercretKey":this.conectParms.client.clientSecret,
            }
        });
        if(!clientAuthResponse || clientAuthResponse.statusCode !== 200 || !clientAuthResponse.data){
            delete this.sessionId;
            this.connectionProccess = false;
            return false;
        }else{
            //再接続データ作成
            this.reConectData = await (async ()=>{
                try{
                    if(!this.keyId || !this.sessionId){
                        this.connectionProccess = false;
                        return null;
                    }
                    const padding = this.crypto.getRandomValues(new Uint8Array(16));
                    if(!padding){
                        this.connectionProccess = false;
                        return null;
                    }
                    const encryptSessionId = await this.crypto.encrypt({sessionId:this.sessionId,padding:btoa(String.fromCharCode(...padding))});
                    if(!encryptSessionId){
                        this.connectionProccess = false;
                        return null;
                    }
                    return {"keyId":this.keyId,"sessionId":this.sessionId,"sign":btoa(String.fromCharCode(...encryptSessionId))}
                }catch(err){
                    this.connectionProccess = false;
                    return null;
                }
            })();
            this.connectionProccess = false;
            if(this.reConectData){
                return true;
            }else{
                return false;
            }
        }
    }

    public hasSession(){
        return this.sessionId?true:false;
    }
    public getSessionData(){
        if(this.sessionId && this.reConectData){
            return {sessionId:this.sessionId,reConnectParamerter:this.reConectData};
        }
        return;
    }

    public async request(apiRequest:{
        "method":"GET"|"POST"|"PUT"|"DELETE",
        "path":string,
        "body"?:any,
        "params"?:any,
        "wOTT"?:boolean,
        "passThrough"?:boolean,
        },options?:{errorRedirectBlock?:boolean}){
        const returnData = {
            statusCode:-1, //HTTP status
            debug:null as any,
            data:{} as unknown,//API 応答ペイロード
            file:undefined as undefined|{
                fileName:string,
                fileBuffer:BufferSource,
            }
        } as ApiResponseData
        const errorRedirectBlock = options?.errorRedirectBlock||false;
        const cryptoPassThrough = apiRequest.passThrough||false;
        if(!this.hasSession()){
            await this.conect();
        }
        if(!this.sessionId){
            return returnData;
        }
        returnData.statusCode--;
        const ottToken:{token:string|null} = {token:null};
        if(apiRequest.wOTT){
            const ottresponse = await this.request({"method":"GET","path":this.conectParms.saver.ottEndPoint});
            if(!ottresponse || ottresponse.statusCode !== 200){
                return returnData;
            }
            if(typeof (ottresponse.data as {token:string}).token === "string"){
                ottToken.token = (ottresponse.data as {token:string}).token;
            }
        }
        const randomValues = new Uint8Array(4);
        const random = this.crypto.getRandomValues(randomValues);
        if(!random){
            return;
        }
        this.seqNo++;
        const s = {
            "a":random[0]+random[1]*256+random[2]*65536+random[3]*16777216,
            "b":random[0]+random[1]*256+random[2]*65536+random[3]*16777216,
            "c":this.seqNo,
        }
        const j = await this.crypto.encrypt(JSON.stringify(s));
        if(!j){
            return;
        }
        switch(apiRequest.method){
            case "GET":
            case "POST":
            case "PUT":
            case "DELETE":
                {
                const headers:{[headername:string]:string} = {};
                if(!cryptoPassThrough){
                    headers[`${this.headerPrefix}-scp-ks`] = this.keyId||"?";
                    headers[`${this.headerPrefix}-scp-sk`] = this.sessionId;
                    headers[`${this.headerPrefix}-scp-sp`] = base64Encode(j);
                }
                if(apiRequest.wOTT){
                    const etoken = await this.crypto.encrypt(ottToken);
                    if(etoken){
                        headers[`${this.headerPrefix}-scp-ot`] = base64Encode(etoken);
                    }
                }
                const options = {
                    "method":apiRequest.method,
                    "url":this.conectParms.saver.host+apiRequest.path,
                    "responseType":"arraybuffer",
                    "params":apiRequest.params,
                    "data":apiRequest.body?(cryptoPassThrough?apiRequest.body:await this.crypto.encrypt(apiRequest.body)):undefined,
                    "headers":headers,
                    "validateStatus":(status)=>{return status<600}
                } as AxiosRequestConfig;
                const apiResponse = await axios(options).then(_=>_).catch(err=>{
                    console.error(err);
                    if(err.response){
                        return err.response;
                    }else if(err.request){
                        returnData.statusCode = -1;
                    }else{
                        returnData.debug = err;
                        returnData.statusCode = -2;
                    }
                });
                if (apiResponse){
                    if(apiResponse.status === 200){
                        returnData.statusCode = 200;
                        if(apiResponse.headers["content-disposition"]){
                            const ContentDisposition = apiResponse.headers["content-disposition"] as string;
                            const fileNameMatch = ContentDisposition.match(contentDispositionFilenameReg);
                            if(fileNameMatch && fileNameMatch.length >= 1){
                                returnData.file = {
                                    "fileName":decodeURIComponent(fileNameMatch[1]),
                                    "fileBuffer":apiResponse.data,
                                }
                            }
                        }else{
                            try{
                                if(apiResponse.data){
                                    returnData.data = cryptoPassThrough?JSON.parse((new TextDecoder().decode(apiResponse.data))):await this.crypto.decrypt(new Uint8Array(apiResponse.data));
                                }else{
                                    returnData.data = null;
                                }
                            }catch(err){
                                console.error(err);
                                returnData.statusCode = -500;
                                returnData.data = null;
                            }
                        }
                    }else if(!errorRedirectBlock && this.sessionId && this.keyId && apiResponse.status === 403){
                        if(apiResponse.data){
                            returnData.data = await this.crypto.decrypt(new Uint8Array(apiResponse.data));
                            if(returnData.data && typeof returnData.data === "object"){
                                const status = (returnData.data as any)["status"];
                                const sessionId = (returnData.data as any)["sessionId"];
                                const keyupdate = (returnData.data as any)["keyupdate"];
                                if(status === "KeyExpriration" && this.sessionId === sessionId){
                                    //Key update
                                    if(await this.conect({keyUpdate:{"sessionId":this.sessionId,"keyId":this.keyId,"token":keyupdate}})){
                                        const subResponseData = await this.request(apiRequest,{"errorRedirectBlock":true});
                                        if(subResponseData){
                                            returnData.statusCode = subResponseData.statusCode;
                                            returnData.data = subResponseData.data;
                                        }
                                    }
                                }
                            }
                        }
                    }else if(!errorRedirectBlock && apiResponse.status === 401 && this.sessionId){
                        //セッション有効期限切れ
                        if(await this.conect()){
                            //再接続
                            const subResponseData = await this.request(apiRequest,{"errorRedirectBlock":true});
                            if(subResponseData){
                                returnData.statusCode = subResponseData.statusCode;
                                returnData.data = subResponseData.data;
                            }
                        }
                    }
                }
                break;
            }
        }
        return returnData;
    }
}

const responseVersionCheck = {
    v_1_0:(response:any):response is KeyResponse10 =>{
        if(typeof response === "object" && response){
            if(response.version === "1.0" && typeof response.payload === "object" && response.payload){
                if(typeof response.payload.sessionID === "string" && typeof response.payload.sign === "string"){
                    if(typeof response.payload.key === "object" && response.payload.key){
                        if(typeof response.payload.key.keyId === "string" && response.payload.key.publicKey){
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    }
}
